import React, { useState, useRef, useEffect } from 'react';
import swal from "sweetalert";

import PageTitle from '../components/PageTitle';
import { SVGICON } from '../constants/theme';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { contactService } from '../../shared/services/apiService';
import '../assets/css/contact-senegal.css';

const contactform = [
    {name:'Nom complet', field: 'name'},
    {name:'Adresse Email', field: 'email', type: 'email'},
    {name:'Téléphone', field: 'phone', type: 'tel'},
    {name:'Sujet', field: 'subject'},
];

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });
    const [loading, setLoading] = useState(false);
    const [captcha, setCaptcha] = useState(false);
    const [recaptchaToken, setRecaptchaToken] = useState('');
    const { executeRecaptcha } = useGoogleReCaptcha();

    // Execute reCAPTCHA when ready
    useEffect(() => {
        let isMounted = true;
        const run = async () => {
            try {
                if (!executeRecaptcha) return; // not yet available
                const token = await executeRecaptcha('contact_submit');
                if (!isMounted) return;
                if (token) {
                    setRecaptchaToken(token);
                    setCaptcha(true);
                } else {
                    setCaptcha(false);
                }
            } catch (err) {
                console.warn('reCAPTCHA execution error:', err);
                setCaptcha(false);
            }
        };
        run();
        return () => { isMounted = false; };
    }, [executeRecaptcha]);

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Form submit
    const form = useRef();
    const sendEmail = async (e) => {
        e.preventDefault();
        
        if (!executeRecaptcha || !recaptchaToken) {
            swal('reCAPTCHA', 'Veuillez vérifier le reCAPTCHA et réessayer.', 'warning');
            return;
        }

        setLoading(true);

        try {
            await contactService.sendMessage({
                ...formData,
                recaptcha_token: recaptchaToken
            });

            swal('Message envoyé!', 'Votre message a été envoyé avec succès. Nous vous répondrons dans les 24 heures.', 'success');
            
            // Reset form
            setFormData({
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: ''
            });
            e.target.reset();
        } catch (error) {
            console.error('Error sending message:', error);
            const errorMessage = error.response?.data?.message || 'Une erreur est survenue. Veuillez réessayer.';
            swal('Erreur', errorMessage, 'error');
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="page-content">
            <PageTitle activePage="Contact Us" mainPage="Home" />
            <section className="map-wrapper1 overflow-hidden  content-inner">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-5 col-lg-5 m-b30">
                            <div className="info-box style-1 ">
                                <div className="info">
                                    <h2 className="text-light wow fadeInUp" data-wow-delay="0.6s">Contactez-nous 🇸🇳</h2>
                                    <p className="wow fadeInUp" data-wow-delay="0.8s">Remplissez le formulaire et notre équipe<br/> vous répondra dans les 24 heures.</p>
                                </div>
                                <div className="widget widget_about">
                                    <div className="widget widget_getintuch">
                                        <ul>
                                            <li className="wow fadeInUp" data-wow-delay="1.0s">
                                                <div className="d-flex align-items-center">
                                                    {SVGICON.Message}
                                                    <span className="text-light">Écrivez-nous</span>
                                                </div>
                                                <p className="m-a0 p-t10">Notre équipe est là pour vous aider.</p>
                                                <h6 className="text-light">contact@senoffre.com</h6>
                                            </li>
                                            <li className="wow fadeInUp" data-wow-delay="1.2s">
                                                <div className=" d-flex align-items-center">
                                                    {SVGICON.Navigate}
                                                    <span className="text-light">Bureau</span>
                                                </div>
                                                <p className=" m-a0 p-t10">Venez nous rendre visite à Dakar.</p>
                                                <h6 className="text-light">Cité Keur Gorgui, Villa N°26, Dakar</h6>
                                            </li>
                                            <li className="wow fadeInUp" data-wow-delay="1.4s">
                                                <div className="d-flex align-items-center">
                                                    {SVGICON.Office}
                                                    <span className="text-light">Téléphone</span>
                                                </div>
                                                <p className=" m-a0 p-t20">Lun-Ven de 8h à 18h (GMT).</p>
                                                <h6 className="text-light">+221 77 499 44 88</h6>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className=" dz-social style-1 wow fadeInUp" data-wow-delay="0.2s">
                                    <h6 className="text-light" >Nos Réseaux Sociaux</h6>
                                    <ul className="social-icon">
                                        <li><a className="social-btn" target="_blank" rel="noreferrer" href="https://www.facebook.com/dexignzone/"><i className="fa-brands fa-facebook-f" /></a></li>
                                        <li><a className="social-btn" target="_blank" rel="noreferrer" href="https://www.instagram.com/dexignzone/"><i className="fa-brands fa-instagram"></i></a></li>
                                        <li><a className="social-btn" target="_blank" rel="noreferrer" href="https://twitter.com/dexignzones"><i className="fa-brands fa-twitter"></i></a></li>
                                        <li><a className="social-btn" target="_blank" rel="noreferrer" href="https://www.youtube.com/@dexignzone1723"><i className="fab fa-youtube"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-7 col-lg-7 col-sm-12 m-b30">
                            <div className="form-wrapper style-1">
                                <h2 className="title m-a0 wow fadeInUp" data-wow-delay="1.6s">Envoyez-nous un message</h2>
                                <p className="font-text text-primary p-b10 wow fadeInUp" data-wow-delay="1.7s">Nous sommes là pour vous. Comment pouvons-nous vous aider ?</p>
                                <div className="contact-area">
                                    <form className="dz-form dzForm style-1 contact-bx" ref={form} onSubmit={sendEmail}>
                                        <div className="dzFormMsg"></div>
                                        <input type="hidden" className="form-control" name="dzToDo" value="Contact" />
                                        <div className="row">
                                            {contactform.map((item, ind)=>(
                                                <div className="col-md-6" key={ind}>
                                                    <div className="input-group wow fadeInUp" data-wow-delay="1.8s">
                                                        <input 
                                                            name={item.field} 
                                                            required 
                                                            type={item.type || 'text'} 
                                                            className="form-control" 
                                                            placeholder={item.name}
                                                            value={formData[item.field]}
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                            <div className="col-md-12">
                                                <div className="input-group wow fadeInUp" data-wow-delay="2.2s">
                                                    <textarea 
                                                        name="message" 
                                                        rows="5" 
                                                        required 
                                                        className="form-control" 
                                                        placeholder="Votre message..."
                                                        value={formData.message}
                                                        onChange={handleInputChange}
                                                    ></textarea>
                                                </div>
                                            </div>
                                            <input type="hidden" name="g-recaptcha-response" value={recaptchaToken} />
                                            <div className="col-md-12 p-t20">
                                                <button 
                                                    name="submit" 
                                                    type="submit" 
                                                    value="Submit" 
                                                    className="btn btn-primary wow fadeInUp" 
                                                    data-wow-delay="2.4s"
                                                    disabled={loading}
                                                >
                                                    {loading ? 'Envoi en cours...' : 'Envoyer le message'}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ContactUs;